export default __webpack_public_path__ + "static/media/professionals.a3142adb.gif";